export default "__VITE_ASSET__ClI2XuFA__"